import { AdminApiError, type AdminEnvelope, get } from './_core.js';

export interface TracingHealth {
  since: string;
  spansPerMinute: Array<{ minute: string; n: number }>;
  sampleReasonBreakdown: Array<{ reason: string; n: number }>;
  activeOverrides: number;
  kindBreakdown: Array<{ kind: string; total: number; errors: number; errorRate: number }>;
}

export async function fetchTracingHealth(): Promise<TracingHealth> {
  const res = await get<TracingHealth>('/admin/system/tracing');
  return res.data;
}

export interface TraceOverride {
  id: string;
  userId: string | null;
  sessionId: string | null;
  expiresAt: string;
  createdBy: string;
  createdAt: string;
}

export async function fetchTraceOverrides(): Promise<{ items: TraceOverride[] }> {
  const res = await get<{ items: TraceOverride[] }>('/admin/system/trace-override');
  return res.data;
}

export async function postTraceOverride(input: {
  userId?: string | undefined;
  sessionId?: string | undefined;
  ttlMinutes?: number | undefined;
}): Promise<{ id: string; expiresAt: string }> {
  const res = await fetch('/api/admin/system/trace-override', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(input),
  });
  const json = (await res.json().catch(() => null)) as AdminEnvelope<{
    id: string;
    expiresAt: string;
  }> | null;
  if (!res.ok || !json || !('success' in json) || json.success !== true) {
    const code = json && 'error' in json ? json.error.code : 'override_failed';
    const msg = json && 'error' in json ? json.error.message : 'override failed';
    throw new AdminApiError(res.status, code, msg);
  }
  return json.data;
}
